export default __webpack_public_path__ + "static/media/wellness kit-mobile.f947d89b.png";